import {SectionInterface} from "../store/types/store";
import {useShelvingStore} from "../store";
import shallow from "zustand/shallow";
import {useCallback} from "react";

export const useUpdateNeighboringBrackets = (currentSections: SectionInterface[], currentSection?: SectionInterface) => {
    const updateBrackets = useShelvingStore((state) => state.updateBrackets, shallow);
    return useCallback(() => {
        const currentSectionIndex = currentSections.findIndex(section => currentSection?.id === section.id)
        const prevSection = currentSections[currentSectionIndex - 1]
        const nextSection = currentSections[currentSectionIndex + 1]
        prevSection?.items.forEach((item) => {
            !prevSection.isIndent && updateBrackets(item.id, prevSection.id, item.position[1])
        })
        nextSection?.items.forEach((item) => {
            !nextSection.isIndent && updateBrackets(item.id, nextSection.id, item.position[1])
        })
    }, [currentSections, currentSection, updateBrackets])
}
